import { UserType } from '@/data/models/user.model';
import { RouteConfig } from 'vue-router';

const routes: Array<RouteConfig> = [
	{
		path: '',
		component: () => import('@/views/utenti/Utenti.vue'),
		meta: {
			title: 'utenti',
			acl: 'section.utenti',
			utype: UserType.ADMIN
		}
	},
	{
		path: 'new',
		component: () => import('@/views/utenti/utente/UtenteDetail.vue'),
		meta: {
			title: 'new-utente',
			acl: 'section.utenti',
			utype: UserType.ADMIN
		}
	},
	{
		path: ':utenteid/edit',
		component: () => import('@/views/utenti/utente/UtenteDetail.vue'),
		props: true,
		meta: {
			title: 'edit-utente',
			acl: 'section.utenti',
			utype: UserType.ADMIN
		}
	}
];

export default routes;